// src/pages/onboarding/OnboardingScreen.jsx
//
// Dedicated post-login route that hosts the OnboardingModal in
// full-screen mode (no MessengerLayout / app chrome behind it).
// Routed at /onboarding — users only land here when the post-login
// redirect helper decided they have an active onboarding journey.

import React from "react";
import { useNavigate } from "react-router-dom";
import OnboardingModal from "../../components/onboarding/OnboardingModal";

export default function OnboardingScreen() {
  const navigate = useNavigate();
  // Completing onboarding advances to the KIRA welcome step (first-login path:
  // login → onboarding → welcome → dashboard). Closing/skipping just drops the
  // user into the app; per the Session A rule they won't be re-routed into
  // onboarding on their next login (onboarding_started is already TRUE).
  const goWelcome   = () => navigate("/welcome");
  const goDashboard = () => navigate("/messenger/dashboard");
  return (
    <div style={{
      minHeight: "100vh",
      width: "100vw",
      background: "#030303",
      position: "relative",
      overflow: "hidden",
    }}>
      <OnboardingModal
        fullScreen={true}
        onClose={goDashboard}
        onComplete={goWelcome}
      />
    </div>
  );
}
